<template>
  <div class="share-center">
    <van-nav-bar title="分享中心" left-arrow @click-left="$router.back()" />

    <div class="wallet-card">
      <div class="wallet-header">
        <div class="wallet-title">可提现佣金 (元)</div>
        <div class="wallet-balance">{{ formatPrice(userInfo.balance) }}</div>
      </div>
      <div class="wallet-footer">
        <div class="frozen-balance">冻结佣金：¥{{ formatPrice(userInfo.frozen_balance) }}</div>
        <van-button type="primary" size="small" round @click="showWithdraw = true">申请提现</van-button>
      </div>
    </div>

    <van-cell-group class="menu-group">
      <van-cell title="邀请好友" icon="share-o" is-link @click="showShare = true" />
      <van-cell title="我的上级" icon="manager-o" :value="userInfo.inviter_name || '无'" />
      <van-cell title="我的下级" icon="friends-o" is-link @click="openSubordinates" />
      <van-cell title="资金流水" icon="balance-list-o" is-link to="/finance-logs" />
      <van-cell title="提现记录" icon="bill-o" is-link to="/withdraw-logs" />
    </van-cell-group>

    <!-- 提现弹窗 -->
    <van-popup v-model="showWithdraw" position="bottom" round class="withdraw-popup">
      <div class="popup-title">申请提现</div>
      <van-form @submit="onSubmitWithdraw">
        <van-field
          v-model="withdrawForm.amount"
          type="number"
          label="提现金额"
          placeholder="请输入提现金额"
          :rules="[{ required: true, message: '请输入提现金额' }]"
        >
          <template #extra>
            <span class="max-amount" @click="withdrawForm.amount = userInfo.balance">全部</span>
          </template>
        </van-field>
        
        <div class="alipay-info-title">收款支付宝信息</div>
        <van-field
          v-model="withdrawForm.alipay_name"
          label="真实姓名"
          placeholder="请输入支付宝认证姓名"
          :rules="[{ required: true, message: '请输入真实姓名' }]"
          :readonly="!!userInfo.alipay_name"
        />
        <van-field
          v-model="withdrawForm.alipay_account"
          label="支付宝账号"
          placeholder="请输入支付宝账号"
          :rules="[{ required: true, message: '请输入支付宝账号' }]"
          :readonly="!!userInfo.alipay_account"
        />
        <div class="form-tip" v-if="userInfo.alipay_account">
          如需修改收款账号，请联系客服处理
        </div>

        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit" :loading="submitting">
            提交申请
          </van-button>
        </div>
      </van-form>
    </van-popup>

    <!-- 分享弹窗 -->
    <van-popup
      v-model="showShare"
      round
      position="bottom"
      :style="{ 'min-height': '10%' }"
    >
      <div>
        <div class="van-share-sheet__options">
          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="copyLink"
          >
            <img
              src="https://img01.yzcdn.cn/vant/share-sheet-link.png"
              class="van-share-sheet__icon"
            /><span class="van-share-sheet__name">复制链接</span>
          </div>
        </div>
        <button
          type="button"
          class="van-share-sheet__cancel"
          @click="showShare = false"
        >
          取消
        </button>
      </div>
    </van-popup>

    <!-- 下级列表弹窗 -->
    <van-popup
      v-model="showSubordinates"
      position="bottom"
      round
      :style="{ height: '70%' }"
      class="subordinates-popup"
    >
      <div class="popup-title">我的下级</div>
      <div class="subordinates-list-wrap">
        <van-pull-refresh v-model="subRefreshing" @refresh="onSubRefresh">
          <van-list
            v-model="subLoading"
            :finished="subFinished"
            finished-text="没有更多了"
            @load="loadSubordinates"
          >
            <van-cell v-for="item in subList" :key="item.id" class="sub-item">
              <template #title>
                <div class="sub-info">
                  <div class="sub-detail">
                    <div class="sub-name">{{ item.nickname || '用户' + item.id }}</div>
                    <div class="sub-time">绑定时间: {{ item.created_at }}</div>
                  </div>
                </div>
              </template>
            </van-cell>
          </van-list>
        </van-pull-refresh>
        
        <div v-if="!subLoading && subList.length === 0" class="empty-state">
          <div class="empty-icon">👥</div>
          <p>暂无下级用户</p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'ShareCenter',
  data() {
    return {
      userInfo: {
        balance: '0.00',
        frozen_balance: '0.00',
        alipay_name: '',
        alipay_account: '',
        inviter_name: ''
      },
      showWithdraw: false,
      showShare: false,
      submitting: false,
      withdrawForm: {
        amount: '',
        alipay_name: '',
        alipay_account: ''
      },
      showSubordinates: false,
      subList: [],
      subLoading: false,
      subFinished: false,
      subRefreshing: false,
      subPage: 1,
      subPageSize: 15
    }
  },
  computed: {
    shareLink() {
      const origin = window.location.origin
      const pathname = window.location.pathname
      const inviterId = this.userInfo.id || ''
      return `${origin}${pathname}?inviter_id=${inviterId}#/payment`
    }
  },
  created() {
    this.loadUserInfo()
  },
  methods: {
    async loadUserInfo() {
      try {
        const res = await this.$common.cusHttp(
          this,
          '/api/saas_finance.php?action=info',
          {},
          'get'
        )
        const data = JSON.parse(res.data)
        if (data.status) {
          this.userInfo = data.data
          this.withdrawForm.alipay_name = this.userInfo.alipay_name || ''
          this.withdrawForm.alipay_account = this.userInfo.alipay_account || ''
        } else {
          this.$toast.fail(data.desc || '获取信息失败')
        }
      } catch (err) {
        console.error('获取信息失败:', err)
      }
    },
    async onSubmitWithdraw() {
      if (this.withdrawForm.amount <= 0) {
        this.$toast('提现金额必须大于0')
        return
      }
      if (Number(this.withdrawForm.amount) > Number(this.userInfo.balance)) {
        this.$toast('可用余额不足')
        return
      }

      this.submitting = true
      try {
        const res = await this.$common.cusHttp(
          this,
          '/api/saas_finance.php?action=withdraw',
          {
            amount: this.withdrawForm.amount,
            alipay_name: this.withdrawForm.alipay_name,
            alipay_account: this.withdrawForm.alipay_account
          },
          'post'
        )
        const data = JSON.parse(res.data)
        if (data.status) {
          this.$toast.success('提现申请成功')
          this.showWithdraw = false
          this.withdrawForm.amount = ''
          this.loadUserInfo()
        } else {
          this.$toast.fail(data.desc || '提现失败')
        }
      } catch (err) {
        console.error('提现失败:', err)
        this.$toast.fail('网络错误，提现失败')
      } finally {
        this.submitting = false
      }
    },
    copyLink() {
      console.log('准备复制的链接:', this.shareLink)
      if (!this.shareLink) {
        this.$toast.fail('分享链接未生成')
        return
      }

      // 优先使用现代 Clipboard API
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(this.shareLink).then(() => {
          this.showShare = false
          this.$toast.success('复制成功')
        }).catch(err => {
          console.error('Clipboard API 复制失败:', err)
          this.fallbackCopyText()
        })
      } else {
        this.fallbackCopyText()
      }
    },
    fallbackCopyText() {
      const textareaEl = document.createElement('textarea')
      textareaEl.value = this.shareLink
      // 防止页面滚动，并将元素移出视口
      textareaEl.style.position = 'fixed'
      textareaEl.style.top = '-9999px'
      textareaEl.style.left = '-9999px'
      textareaEl.setAttribute('readonly', 'readonly')
      
      document.body.appendChild(textareaEl)
      
      // 兼容 iOS 的选中方式
      if (navigator.userAgent.match(/ipad|iphone/i)) {
        const range = document.createRange()
        range.selectNodeContents(textareaEl)
        const selection = window.getSelection()
        selection.removeAllRanges()
        selection.addRange(range)
        textareaEl.setSelectionRange(0, 999999)
      } else {
        textareaEl.select()
      }

      try {
        const res = document.execCommand('copy')
        console.log('降级复制执行结果:', res)
        if (res) {
          this.$toast.success('复制成功')
        } else {
          this.$toast.fail('复制失败，请手动复制')
        }
      } catch (err) {
        console.error('降级复制报错:', err)
        this.$toast.fail('复制失败，请手动复制')
      }
      
      document.body.removeChild(textareaEl)
      this.showShare = false
    },
    formatPrice(price) {
      if (!price) return '0.00'
      return Number(price).toFixed(2)
    },
    openSubordinates() {
      this.showSubordinates = true
      this.onSubRefresh()
    },
    async loadSubordinates() {
      try {
        const res = await this.$common.cusHttp(
          this,
          `/api/saas_finance.php?action=subordinates&page=${this.subPage}&pageSize=${this.subPageSize}`,
          {},
          'get'
        )
        const data = JSON.parse(res.data)
        if (data.status) {
          const list = data.data.list || []
          
          if (this.subRefreshing) {
            this.subList = []
            this.subRefreshing = false
          }
          
          this.subList.push(...list)
          this.subPage++

          if (list.length < this.subPageSize) {
            this.subFinished = true
          }
        } else {
          this.subFinished = true
          this.subRefreshing = false
        }
      } catch (err) {
        console.error('加载下级列表失败:', err)
        this.subFinished = true
        this.subRefreshing = false
      } finally {
        this.subLoading = false
      }
    },
    onSubRefresh() {
      this.subFinished = false
      this.subLoading = true
      this.subPage = 1
      this.loadSubordinates()
    }
  }
}
</script>

<style scoped>
.share-center {
  min-height: 100vh;
  background-color: #f7f8fa;
}

.wallet-card {
  margin: 16px;
  padding: 24px 20px;
  background: linear-gradient(135deg, #1989fa, #0570db);
  border-radius: 12px;
  color: #fff;
  box-shadow: 0 4px 12px rgba(25, 137, 250, 0.3);
}

.wallet-title {
  font-size: 14px;
  opacity: 0.9;
  margin-bottom: 8px;
}

.wallet-balance {
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 20px;
}

.wallet-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding-top: 16px;
}

.frozen-balance {
  font-size: 14px;
  opacity: 0.9;
}

.menu-group {
  margin: 16px;
  border-radius: 8px;
  overflow: hidden;
}

.withdraw-popup {
  padding-bottom: 20px;
}

.popup-title {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  padding: 16px 0;
  border-bottom: 1px solid #ebedf0;
}

.max-amount {
  color: #1989fa;
  font-size: 14px;
}

.alipay-info-title {
  padding: 16px 16px 8px;
  font-size: 14px;
  color: #969799;
  background-color: #f7f8fa;
}

.form-tip {
  padding: 8px 16px;
  font-size: 12px;
  color: #ed6a0c;
}

.subordinates-popup {
  display: flex;
  flex-direction: column;
}

.subordinates-list-wrap {
  flex: 1;
  overflow-y: auto;
  background: #f7f8fa;
}

.sub-item {
  margin-bottom: 8px;
}

.sub-info {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.sub-detail {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.sub-name {
  font-size: 14px;
  color: #333;
  margin-bottom: 4px;
}

.sub-time {
  font-size: 12px;
  color: #999;
}

.empty-state {
  text-align: center;
  padding: 60px 0;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.empty-state p {
  color: #999;
  font-size: 14px;
}
</style>
